<div class="grid-order d-flex flex-column h-100">
  <button *ngIf="showCancelAllBtn && thereAreRowsInTheGrid" mat-raised-button color="sell" class="cancel-all"
    (click)="cancelOrder(null, true)" matTooltipPosition="above" [matTooltip]="tooltipCancelAll">
    Cancelar
  </button>
  <ag-grid-angular #wksOrder style="width: 100%; height: 100%;" class="ag-theme-balham" [rowData]="[]"
    [columnDefs]="columnDefsOrders" [gridOptions]="gridOptionsOrders" (gridReady)="onGridReady($event)"
    (viewportChanged)="rowsUpdated($event)">
  </ag-grid-angular>
</div>
